module.exports = "<svg id=Слой_1 data-name=\"Слой 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 122 68\"><defs><style>.cls-1{fill:none;stroke:#c6c6c6;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}</style></defs><title>Search</title><ellipse class=cls-1 cx=58.49 cy=31.5 rx=14.57 ry=14.5 /><line class=cls-1 x1=68.8 y1=41.76 x2=78.08 y2=51 /></svg>";


//////////////////
// WEBPACK FOOTER
// ./public/web/images/search-01.svg
// module id = aK2u
// module chunks = 3 4